export default __webpack_public_path__ + "static/media/1887.81d2d2a2.png";